module.exports = __webpack_public_path__ + "static/img/logo.e81a14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 2